export type Lang = "fi" | "en";

export const translations = {
  fi: {
    nav: {
      products: "Tuotteet",
      features: "Ominaisuudet",
      pricing: "",
      login: "Kirjaudu",
      joinWaitlist: "Liity jonotuslistalle",
      langLabel: "FI",
    },
    hero: {
      badge: "Esittelyssä Worklly",
      heading: "Työskentele fiksummin.",
      headingAccent: " Saa maksut nopeammin.",
      subtitle: "Projektit. Tehtävät. Laskut. Yksi alusta — rakennettu pohjoismaisille pk-yrityksille.",
      cta: "Liity jonotuslistalle",
      learnMore: "Lue lisää",
    },
    overview: {
      heading: "Kaikki tarvittava työn hallintaan ja laskutukseen",
      bullets: [
        "Seuraa läsnäoloa ja hallitse työvoimaasi reaaliajassa",
        "Hallitse projekteja ja tehtäviä alusta loppuun",
        "Luo laskuja ja seuraa maksuja vaivattomasti",
      ],
      exploreAll: "Tutustu kaikkiin ominaisuuksiin",
    },
    products: [
      {
        title: "Läsnäolon seuranta",
        desc: "Tiedä kuka työskentelee ja milloin — reaaliajassa. Saat välittömät hälytykset kun tiimin jäsenet kirjautuvat sisään, näet aktiviteettiaikalinjat ja seuraat työvoiman läsnäoloa puhelimestasi.",
        features: ["Reaaliaikaiset kirjautumishälytykset", "Työntekijäkohtainen aktiviteettilinja", "Myöhästymisten ja poissaolojen seuranta"],
      },
      {
        title: "Projektinhallinta",
        desc: "Suunnittele, delegoi ja seuraa projekteja kokonaisvaltaisesti tehokkaalla työpöydällä. Aseta määräajat, seuraa budjetteja ja pidä jokainen tiimin jäsen linjassa.",
        features: ["Visuaaliset hallintapaneelit ja edistymisen seuranta", "Tiimin tehtävät ja aikataulutus", "Budjettiseuranta ja resurssien hallinta"],
      },
      {
        title: "Tehtävien hallinta",
        desc: "Luo, delegoi ja seuraa tehtäviä kaikissa projekteissasi. Saat ilmoituksen heti kun työ valmistuu ja projekti on valmis laskutettavaksi.",
        features: ["Tehtävien luonti ja delegointi", "Valmiusilmoitukset ja tilaseuranta", "Automaattiset laskuvalmiusilmoitukset"],
      },
      {
        title: "Laskujen luonti",
        desc: "Muuta valmiit projektit ammattimaisiksi laskuiksi yhdellä klikkauksella. Automaattinen asiakastietojen, rivien ja veron täyttö — vie PDF:nä tai lähetä suoraan.",
        features: ["Laskun luonti yhdellä klikkauksella", "Automaattiset summat ja verolaskelmat", "PDF-vienti ja suora sähköpostitoimitus"],
      },
      {
        title: "Maksut",
        desc: "Saat välittömän vahvistuksen kun lasku maksetaan. Seuraa jokaista maksua, näe avoimet saldot ja pidä kassavirta aina näkyvillä.",
        features: ["Välittömät maksuvahvistukset", "Avointen saldojen seuranta", "Täydellinen laskutus- ja maksuhistoria"],
      },
    ],
    accordion: {
      heading: "Kattavat ominaisuudet",
      subtitle: "Kaikki mitä Worklly tarjoaa työpäiväsi tehostamiseen.",
      items: [
        { title: "Läsnäolon seuranta", desc: "Reaaliaikaiset kirjautumishälytykset, aktiviteettiaikalinjat ja työvoiman läsnäolon seuranta. Tiedä kuka on paikalla, kuka myöhässä ja kuka työskentelee — puhelimesta tai tietokoneelta." },
        { title: "Projektinhallinta", desc: "Hallitse projekteja kokonaisvaltaisesti. Delegoi tiimin jäsenille, aseta määräajat, seuraa edistymistä visuaalisilla hallintapaneeleilla ja pidä budjetit hallinnassa." },
        { title: "Tehtävien hallinta", desc: "Luo, delegoi ja seuraa tehtäviä projekteissa. Saat ilmoituksen heti kun tehtävä valmistuu ja projekti on valmis laskutettavaksi." },
        { title: "Laskujen luonti", desc: "Luo ammattimaisia laskuja suoraan valmiista projekteista. Automaattinen rivien täyttö, verolaskenta ja PDF-vienti yhdellä klikkauksella." },
        { title: "Maksut", desc: "Välittömät maksuvahvistukset, laskujen tilaseuranta ja täydellinen maksuhistoria. Kassavirtasi pysyy aina näkyvillä." },
      ],
    },
    why: {
      heading: "Miksi tiimit valitsevat Workllya",
      subtitle: "Kaikki mitä tarvitset pienen yrityksesi pyörittämiseen — ilman monimutkaisia yritystyökaluja.",
      cards: [
        { title: "Säästä aikaa", desc: "Projektin perustamisesta laskun lähettämiseen — mikä ennen vei tunteja, hoituu nyt minuuteissa automaattisilla työnkuluilla." },
        { title: "Pysy ajan tasalla", desc: "Reaaliaikaiset ilmoitukset pitävät kaikki linjassa. Ei enää päivitysten perässä juoksemista — Worklly tuo ne sinulle." },
        { title: "Saat maksun nopeammin", desc: "Automaattinen laskutus ja välitön maksuseuranta tarkoittavat vähemmän odottelua ja enemmän aikaa liiketoiminnan kasvattamiseen." },
      ],
    },
    cta: {
      heading: "Valmiina yksinkertaistamaan työpäiväsi?",
      subtitle: "Ole ensimmäisten joukossa kokemassa yksinkertaisempi tapa hallita projekteja, tehtäviä ja laskuja.",
      primary: "Liity jonotuslistalle",
      secondary: "Tutustu ominaisuuksiin",
    },
    footer: {
      tagline: "Yksinkertainen työnhallinta pienille ja keskisuurille yrityksille.",
      productsTitle: "Tuotteet",
      productLinks: ["Läsnäolon seuranta", "Projektinhallinta", "Tehtävien hallinta", "Laskujen luonti", "Maksut"],
      supportTitle: "Tuki",
      supportLinks: ["Tukikeskus", "Yhteisö", "Ota yhteyttä", "API-dokumentaatio"],
      legalTitle: "Laillisuus",
      legalLinks: ["Tietosuojaseloste", "Käyttöehdot", "Evästekäytäntö"],
      copyright: "2025 Worklly. Kaikki oikeudet pidätetään.",
      location: "Helsinki, Suomi",
    },
    signup: {
      backToHome: "Takaisin etusivulle",
      heading: "Varaa paikkasi aikaisin",
      headingAccent: " — lanseeraamme pian.",
      subtitle: "Worklly yhdistää projektinhallinnan, tehtävien seurannan ja laskutuksen yhteen yksinkertaiseen työkaluun pk-yrityksille.",
      features: [
        "Läsnäolon seuranta ja työvoimanhallinta",
        "Projekti- ja tehtävienhallinta alusta loppuun",
        "Automaattinen laskutus ja maksuseuranta",
      ],
      earlyAccessBadge: "Rajoitettu varhainen pääsy",
      earlyAccessNote: "Ensimmäiset käyttäjät saavat ilmaisen pääsyn lanseerauksessa — ei luottokorttia tarvita.",
      formHeading: "Liity jonotuslistalle",
      formSubtitle: "Täytä tietosi ja ilmoitamme kun Worklly on valmis.",
      businessNameLabel: "Yrityksen nimi",
      businessNamePlaceholder: "Oy Yritys Ab",
      businessSizeLabel: "Yrityksen koko",
      businessSizes: { solo: "1 henkilö", small: "2–10", medium: "11–50", large: "51–200", enterprise: "200+" },
      industryLabel: "Toimiala",
      industries: { services: "Palvelut", construction: "Rakentaminen", consulting: "Konsultointi", technology: "Teknologia", other: "Muu" },
      fullNameLabel: "Koko nimi",
      fullNamePlaceholder: "Matti Meikäläinen",
      emailLabel: "Työsähköpostiosoite",
      emailPlaceholder: "nimi@yritys.fi",
      roleLabel: "Roolisi",
      rolePlaceholder: "esim. Projektipäällikkö, Toimitusjohtaja, Talouspäällikkö",
      topFeaturesLabel: "Mitkä 2 ominaisuutta kiinnostavat eniten?",
      topFeaturesHint: "Valitse 2",
      featureOptions: [
        { key: "attendance", label: "Läsnäolon seuranta", icon: "badge" },
        { key: "projects", label: "Projektinhallinta", icon: "dashboard" },
        { key: "tasks", label: "Tehtävien hallinta", icon: "task_alt" },
        { key: "invoicing", label: "Laskujen luonti", icon: "receipt_long" },
        { key: "payments", label: "Maksut", icon: "paid" },
        { key: "reporting", label: "Raportointi ja analytiikka", icon: "bar_chart" },
      ],
      currentToolLabel: "Nykyinen prosessi tai työkalu",
      currentToolPlaceholder: "esim. Excel, kynä ja paperi, ei mitään, toinen ohjelmisto...",
      startTimelineLabel: "Milloin haluaisit aloittaa?",
      startTimelines: { asap: "Heti kun mahdollista", quarter: "1–3 kuukauden sisällä", halfYear: "3–6 kuukautta", exploring: "Vasta tutustumassa" },
      submitBtn: "Liity jonotuslistalle",
      legal: "Liittymällä hyväksyt",
      terms: "käyttöehdot",
      and: " ja ",
      privacy: "tietosuojaselosteen",
      successHeading: "Olet listalla!",
      successText: "Ilmoitamme sinulle ensimmäisenä kun Worklly on valmis. Pidä silmällä sähköpostiasi.",
      successBack: "Takaisin etusivulle",
      footerCopyright: "2025 Worklly. Kaikki oikeudet pidätetään.",
      footerTagline: "Worklly on projektinhallinta- ja tuottavuustyökalu.",
    },
    screens: {
      s1: {
        lockSub: "Keskiviikko \u2022 Worklly-hälytykset",
        notifTitle: "Käyttäjä kirjautui",
        notifText: "kirjautui juuri sisään.",
        notifBadge: "\u2022 Aktiviteetti kirjattu",
      },
      s2: {
        dashboard: "Ohjauspaneeli",
        employees: "Työntekijät",
        schedules: "Aikataulut",
        reports: "Raportit",
        day: "21",
        dateMeta: "Helmikuu 2025,\nPerjantai",
        employeesLabel: "Työntekijät",
        present: "Paikalla",
        absent: "Poissa",
        late: "Myöhässä",
        devices: "Laitteet",
        allDevices: "Kaikki laitteet",
        todayHeading: "Mitä Workllyssa tapahtuu tänään",
        search: "Hae",
        thEmployee: "Työntekijä",
        thFirstArrival: "Ensimmäinen tulo",
        thLastDeparture: "Viimeinen lähtö",
        thLate: "Myöhässä",
        thEarlyDeparture: "Aikainen lähtö",
        showing: "Näytetään 1–5 / 18",
        topPerformers: "Parhaat suoriutujat",
      },
      s3: {
        lockSub: "Keskiviikko \u2022 Worklly-päivitykset",
        notifs: [
          { title: "Vesiputkitehtävä valmis", text: "Suorittanut {name}.", badge: "\u2022 Tehtävä valmis" },
          { title: "Lattianpäällystehtävä valmis", text: "Suorittanut {name}.", badge: "\u2022 Tehtävä valmis" },
          { title: "Lasinasennustehtävä valmis", text: "Suorittanut {name}.", badge: "\u2022 Tehtävä valmis" },
          { title: "Projekti valmis: Vuosihuolto", text: "Valmis laskutettavaksi.", badge: "\u2022 Laskutusvalmis" },
        ],
      },
      s4: {
        dashboard: "Ohjauspaneeli",
        employees: "Työntekijät",
        invoicing: "Laskutus",
        reports: "Raportit",
        createInvoice: "Luo lasku",
        allInvoices: "Kaikki laskut",
        payments: "Maksut",
        customers: "Asiakkaat",
        projects: "Projektit",
        settings: "Asetukset",
        invoiceBuilderActive: "Laskunluoja aktiivinen",
        pageTitle: "Luo lasku",
        pageSubtitle: "Täytä tiedot ja lisää rivejä. Summat päivittyvät automaattisesti.",
        addRow: "+ Lisää rivi",
        fillDemo: "Täytä demo",
        generatePdf: "Luo PDF",
        invoiceDetails: "Laskun tiedot",
        invoiceDetailsDesc: "Asiakastiedot ja veloitusrivit.",
        customerName: "Asiakkaan nimi",
        customerEmail: "Asiakkaan sähköposti",
        invoiceNumber: "Laskun numero",
        invoiceDate: "Laskun päivä",
        dueDate: "Eräpäivä",
        notes: "Lisätiedot (valinnainen)",
        notesPlaceholder: "esim. Kiitos liiketoiminnasta.",
        charges: "Veloitukset",
        thDesc: "Kuvaus",
        thAmount: "Summa (€)",
        thTaxPct: "ALV %",
        thTax: "ALV (€)",
        descPlaceholder: "esim. Huoltotyö",
        ibanNote: "IBAN sisällytetty luotuun PDF:iin",
        totals: "Yhteenveto",
        totalsDesc: "Laskettu veloitusriveistä.",
        subtotal: "Välisumma",
        taxTotal: "ALV yhteensä",
        totalToPay: "Maksettava yhteensä",
        paymentDetails: "Maksutiedot",
        paymentDetailsDesc: "Näytetään luodussa laskussa.",
        receiver: "Saaja",
        iban: "IBAN",
        recentInvoices: "Viimeisimmät laskut",
        recentInvoicesDesc: "Viimeiset 3 luotua laskua.",
        paid: "Maksettu",
        pending: "Odottaa",
        demoFilled: "Demorivit täytetty",
        pdfGenerated: "PDF luotu (demo)",
        demoRows: [
          { desc: "Vuosihuolto – työ", amount: "1200", tax: "24" },
          { desc: "Materiaalit ja tarvikkeet", amount: "480", tax: "24" },
          { desc: "Matkakulut", amount: "120", tax: "24" },
        ],
      },
      s5: {
        lockSub: "Keskiviikko \u2022 Worklly-laskutus",
        notifTitle: "Lasku maksettu",
        notifText: "Lasku projektista {project} on maksettu.",
        notifBadge: "\u2022 Maksu vastaanotettu",
        projectName: "Vuosihuolto",
      },
    },
  },
  en: {
    nav: {
      products: "Products",
      features: "Features",
      pricing: "Pricing",
      login: "Log in",
      joinWaitlist: "Join Waitlist",
      langLabel: "EN",
    },
    hero: {
      badge: "Introducing Worklly",
      heading: "Work Smarter.",
      headingAccent: " Get Paid Faster.",
      subtitle: "Projects. Tasks. Invoices. One platform — built for Nordic SMEs.",
      cta: "Join Waitlist",
      learnMore: "Learn More",
    },
    overview: {
      heading: "Everything you need to manage work and get paid",
      bullets: [
        "Track attendance and manage your workforce in real time",
        "Run projects and tasks from start to finish",
        "Generate invoices and track payments effortlessly",
      ],
      exploreAll: "Explore all features",
    },
    products: [
      {
        title: "Attendance Tracking",
        desc: "Know who's working and when — in real time. Get instant alerts when team members clock in, view activity timelines, and monitor workforce presence from your phone.",
        features: ["Real-time login and clock-in alerts", "Per-employee activity timeline", "Late arrival and absence monitoring"],
      },
      {
        title: "Project Management",
        desc: "Plan, assign, and track projects end-to-end in a powerful desktop dashboard. Set deadlines, monitor budgets, and keep every team member aligned on priorities.",
        features: ["Visual dashboards with progress tracking", "Team assignments and deadline management", "Budget monitoring and resource allocation"],
      },
      {
        title: "Task Management",
        desc: "Create, assign, and track tasks across all your projects. Get notified the moment work is completed and projects become invoice-ready.",
        features: ["Task creation and assignment", "Completion alerts and status tracking", "Automatic invoice-ready notifications"],
      },
      {
        title: "Invoice Generation",
        desc: "Turn completed projects into professional invoices in one click. Auto-fill client details, line items, and tax — then export as PDF or send directly.",
        features: ["One-click invoice from any project", "Auto-calculated totals and tax", "PDF export and direct email delivery"],
      },
      {
        title: "Payments",
        desc: "Get instant confirmation the moment an invoice is paid. Track every payment, see outstanding balances, and keep your cash flow visible at all times.",
        features: ["Instant payment confirmations", "Outstanding balance tracking", "Complete billing and payment history"],
      },
    ],
    accordion: {
      heading: "Comprehensive Features",
      subtitle: "Everything Worklly offers to streamline your workday.",
      items: [
        { title: "Attendance Tracking", desc: "Real-time login alerts, activity timelines, and workforce presence monitoring. Know who's on-site, who's late, and who's working — all from your phone or desktop." },
        { title: "Project Management", desc: "Organize projects end-to-end. Assign team members, set deadlines, track progress with visual dashboards, and keep budgets on target." },
        { title: "Task Management", desc: "Create, assign, and track tasks across projects. Get notified the moment tasks are completed and projects become invoice-ready." },
        { title: "Invoice Generation", desc: "Create professional invoices directly from completed projects. Auto-fill line items, calculate tax, and export as PDF in one click." },
        { title: "Payments", desc: "Instant payment confirmations, invoice status tracking, and complete billing history. Your cash flow stays visible at all times." },
      ],
    },
    why: {
      heading: "Why Teams Choose Worklly",
      subtitle: "Everything you need to run your small business — without the complexity of enterprise tools.",
      cards: [
        { title: "Save Time", desc: "From project setup to sending invoices — what used to take hours now takes minutes with automated workflows." },
        { title: "Stay In Sync", desc: "Real-time notifications keep everyone aligned. No more chasing updates — Worklly brings them to you." },
        { title: "Get Paid Faster", desc: "Automated invoicing and instant payment tracking means less time waiting and more time growing your business." },
      ],
    },
    cta: {
      heading: "Ready to simplify your workday?",
      subtitle: "Be the first to experience a simpler way to manage projects, tasks, and invoices.",
      primary: "Join Waitlist",
      secondary: "Explore Features",
    },
    footer: {
      tagline: "Simple work management for small and medium enterprises.",
      productsTitle: "Products",
      productLinks: ["Attendance Tracking", "Project Management", "Task Management", "Invoice Generation", "Payments"],
      supportTitle: "Support",
      supportLinks: ["Help Center", "Community", "Contact Us", "API Docs"],
      legalTitle: "Legal",
      legalLinks: ["Privacy Policy", "Terms of Service", "Cookie Policy"],
      copyright: "2025 Worklly. All rights reserved.",
      location: "Helsinki, Finland",
    },
    signup: {
      backToHome: "Back to Home",
      heading: "Get early access",
      headingAccent: " — launching soon.",
      subtitle: "Worklly combines project management, task tracking, and invoicing into one simple tool built for SMEs.",
      features: [
        "Attendance tracking and workforce management",
        "End-to-end project and task management",
        "Automated invoicing and payment tracking",
      ],
      earlyAccessBadge: "Limited Early Access",
      earlyAccessNote: "First users get free access at launch — no credit card required.",
      formHeading: "Join the Waitlist",
      formSubtitle: "Fill in your details and we'll notify you when Worklly is ready.",
      businessNameLabel: "Business name",
      businessNamePlaceholder: "Acme Oy",
      businessSizeLabel: "Business size",
      businessSizes: { solo: "Just me", small: "2–10", medium: "11–50", large: "51–200", enterprise: "200+" },
      industryLabel: "Industry",
      industries: { services: "Services", construction: "Construction", consulting: "Consulting", technology: "Technology", other: "Other" },
      fullNameLabel: "Full name",
      fullNamePlaceholder: "John Smith",
      emailLabel: "Work email address",
      emailPlaceholder: "name@company.com",
      roleLabel: "Your role",
      rolePlaceholder: "e.g. Project Manager, CEO, Finance Lead",
      topFeaturesLabel: "Which 2 features interest you most?",
      topFeaturesHint: "Pick 2",
      featureOptions: [
        { key: "attendance", label: "Attendance Tracking", icon: "badge" },
        { key: "projects", label: "Project Management", icon: "dashboard" },
        { key: "tasks", label: "Task Management", icon: "task_alt" },
        { key: "invoicing", label: "Invoice Generation", icon: "receipt_long" },
        { key: "payments", label: "Payments", icon: "paid" },
        { key: "reporting", label: "Reporting & Analytics", icon: "bar_chart" },
      ],
      currentToolLabel: "Current process or tool",
      currentToolPlaceholder: "e.g. Excel, pen & paper, nothing, another software...",
      startTimelineLabel: "When would you like to start?",
      startTimelines: { asap: "As soon as possible", quarter: "Within 1–3 months", halfYear: "3–6 months", exploring: "Just exploring" },
      submitBtn: "Join Waitlist",
      legal: "By joining, you agree to our",
      terms: "Terms of Service",
      and: " and ",
      privacy: "Privacy Policy",
      successHeading: "You're on the list!",
      successText: "We'll notify you first when Worklly is ready. Keep an eye on your inbox.",
      successBack: "Back to Home",
      footerCopyright: "2025 Worklly. All rights reserved.",
      footerTagline: "Worklly is a project management and productivity tool.",
    },
    screens: {
      s1: {
        lockSub: "Wednesday \u2022 Worklly alerts",
        notifTitle: "User logged in",
        notifText: "just logged in.",
        notifBadge: "\u2022 Activity recorded",
      },
      s2: {
        dashboard: "Dashboard",
        employees: "Employees",
        schedules: "Schedules",
        reports: "Reports",
        day: "21",
        dateMeta: "February 2025,\nFriday",
        employeesLabel: "Employees",
        present: "Present",
        absent: "Absent",
        late: "Late",
        devices: "Devices",
        allDevices: "All devices",
        todayHeading: "What's happening at Worklly today",
        search: "Search",
        thEmployee: "Employee",
        thFirstArrival: "First arrival",
        thLastDeparture: "Last departure",
        thLate: "Late",
        thEarlyDeparture: "Early departure",
        showing: "Showing 1\u20135 of 18",
        topPerformers: "Top Performers",
      },
      s3: {
        lockSub: "Wednesday \u2022 Worklly updates",
        notifs: [
          { title: "Water pipes task done", text: "Completed by {name}.", badge: "\u2022 Task completed" },
          { title: "New flooring task done", text: "Completed by {name}.", badge: "\u2022 Task completed" },
          { title: "New glass pane installation task done", text: "Completed by {name}.", badge: "\u2022 Task completed" },
          { title: "Project finished: Annual maintenance", text: "Ready for invoicing.", badge: "\u2022 Invoice-ready" },
        ],
      },
      s4: {
        dashboard: "Dashboard",
        employees: "Employees",
        invoicing: "Invoicing",
        reports: "Reports",
        createInvoice: "Create Invoice",
        allInvoices: "All Invoices",
        payments: "Payments",
        customers: "Customers",
        projects: "Projects",
        settings: "Settings",
        invoiceBuilderActive: "Invoice builder active",
        pageTitle: "Create Invoice",
        pageSubtitle: "Fill in the details and add charge rows. Totals update automatically.",
        addRow: "+ Add Row",
        fillDemo: "Fill Demo",
        generatePdf: "Generate PDF",
        invoiceDetails: "Invoice Details",
        invoiceDetailsDesc: "Customer information and charge items.",
        customerName: "Customer Name",
        customerEmail: "Customer Email",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        dueDate: "Due Date",
        notes: "Notes (optional)",
        notesPlaceholder: "e.g., Thank you for your business.",
        charges: "Charges",
        thDesc: "Description",
        thAmount: "Amount (\u20AC)",
        thTaxPct: "Tax %",
        thTax: "Tax (\u20AC)",
        descPlaceholder: "e.g., Maintenance labor",
        ibanNote: "IBAN included in generated PDF",
        totals: "Totals",
        totalsDesc: "Calculated from charge rows.",
        subtotal: "Subtotal",
        taxTotal: "Tax Total",
        totalToPay: "Total to Pay",
        paymentDetails: "Payment Details",
        paymentDetailsDesc: "Shown on the generated invoice PDF.",
        receiver: "Receiver",
        iban: "IBAN",
        recentInvoices: "Recent Invoices",
        recentInvoicesDesc: "Last 3 generated invoices.",
        paid: "Paid",
        pending: "Pending",
        demoFilled: "Demo rows filled",
        pdfGenerated: "PDF generated (demo)",
        demoRows: [
          { desc: "Annual maintenance \u2013 labor", amount: "1200", tax: "24" },
          { desc: "Materials & supplies", amount: "480", tax: "24" },
          { desc: "Travel costs", amount: "120", tax: "24" },
        ],
      },
      s5: {
        lockSub: "Wednesday \u2022 Worklly billing",
        notifTitle: "Invoice paid",
        notifText: "Invoice for project {project} is paid.",
        notifBadge: "\u2022 Payment received",
        projectName: "Annual Maintenance",
      },
    },
  },
};

interface AccordionItem { title: string; desc: string; }
interface WhyCard { title: string; desc: string; }
interface ProductTranslation { title: string; desc: string; features: string[]; }

export interface Translations {
  nav: { products: string; features: string; pricing: string; login: string; joinWaitlist: string; langLabel: string; };
  hero: { badge: string; heading: string; headingAccent: string; subtitle: string; cta: string; learnMore: string; };
  overview: { heading: string; bullets: string[]; exploreAll: string; };
  products: ProductTranslation[];
  accordion: { heading: string; subtitle: string; items: AccordionItem[]; };
  why: { heading: string; subtitle: string; cards: WhyCard[]; };
  cta: { heading: string; subtitle: string; primary: string; secondary: string; };
  footer: { tagline: string; productsTitle: string; productLinks: string[]; supportTitle: string; supportLinks: string[]; legalTitle: string; legalLinks: string[]; copyright: string; location: string; };
  signup: {
    backToHome: string;
    heading: string;
    headingAccent: string;
    subtitle: string;
    features: string[];
    earlyAccessBadge: string;
    earlyAccessNote: string;
    formHeading: string;
    formSubtitle: string;
    businessNameLabel: string;
    businessNamePlaceholder: string;
    businessSizeLabel: string;
    businessSizes: { solo: string; small: string; medium: string; large: string; enterprise: string; };
    industryLabel: string;
    industries: { services: string; construction: string; consulting: string; technology: string; other: string; };
    fullNameLabel: string;
    fullNamePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    roleLabel: string;
    rolePlaceholder: string;
    topFeaturesLabel: string;
    topFeaturesHint: string;
    featureOptions: { key: string; label: string; icon: string; }[];
    currentToolLabel: string;
    currentToolPlaceholder: string;
    startTimelineLabel: string;
    startTimelines: { asap: string; quarter: string; halfYear: string; exploring: string; };
    submitBtn: string;
    legal: string;
    terms: string;
    and: string;
    privacy: string;
    successHeading: string;
    successText: string;
    successBack: string;
    footerCopyright: string;
    footerTagline: string;
  };
  screens: {
    s1: { lockSub: string; notifTitle: string; notifText: string; notifBadge: string; };
    s2: {
      dashboard: string; employees: string; schedules: string; reports: string;
      day: string; dateMeta: string; employeesLabel: string;
      present: string; absent: string; late: string;
      devices: string; allDevices: string;
      todayHeading: string; search: string;
      thEmployee: string; thFirstArrival: string; thLastDeparture: string; thLate: string; thEarlyDeparture: string;
      showing: string; topPerformers: string;
    };
    s3: { lockSub: string; notifs: { title: string; text: string; badge: string; }[]; };
    s4: {
      dashboard: string; employees: string; invoicing: string; reports: string;
      createInvoice: string; allInvoices: string; payments: string; customers: string; projects: string; settings: string;
      invoiceBuilderActive: string; pageTitle: string; pageSubtitle: string;
      addRow: string; fillDemo: string; generatePdf: string;
      invoiceDetails: string; invoiceDetailsDesc: string;
      customerName: string; customerEmail: string; invoiceNumber: string; invoiceDate: string; dueDate: string;
      notes: string; notesPlaceholder: string; charges: string;
      thDesc: string; thAmount: string; thTaxPct: string; thTax: string; descPlaceholder: string;
      ibanNote: string; totals: string; totalsDesc: string;
      subtotal: string; taxTotal: string; totalToPay: string;
      paymentDetails: string; paymentDetailsDesc: string; receiver: string; iban: string;
      recentInvoices: string; recentInvoicesDesc: string; paid: string; pending: string;
      demoFilled: string; pdfGenerated: string;
      demoRows: { desc: string; amount: string; tax: string; }[];
    };
    s5: { lockSub: string; notifTitle: string; notifText: string; notifBadge: string; projectName: string; };
  };
}
